import UserConfig from "./UserConfig";
import AuthService from "../auth/AuthService"
export default class UserService {

  /******* USERS **********/
  static getUsers(app) {
    
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = UserConfig.endpointUsers;
        let response = await UserConfig.APIConnector.get(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
        });
        // console.log("getUsers", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static getUsersByEmailOrDU(app,usersDU, usersEmail) {
    
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = UserConfig.endpointUsersByEmailOrDU;
        let response = await UserConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify({usersDU:usersDU, usersEmail:usersEmail})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        console.log("ERROR",e)
        reject(e)
      }
    });
  }

  
  static getUsersFromStorage(path, filename) {
    
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = UserConfig.endpointUsersFromStorage;
        let response = await UserConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token },
            body: JSON.stringify({path:path, filename:filename})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static saveUser(app, user) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = UserConfig.endpointSaveUser;
        let response = await UserConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify(user)
        });
        // console.log("RESPONSE SAVE USER",response)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static deleteUser(app,userId) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = UserConfig.endpointDeleteUser;
        let response = await UserConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({id:userId})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static sendNotification(app, user, notification){
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = UserConfig.endpointSendNotification;
        let response = await UserConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({userToken:user.FCMToken, notification:notification})
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  /******** FIN USERS *********/
  /******** DELIVERYS *********/
  static getDeliveryBoys(filter, app) {
    
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = UserConfig.endpointDeliverys;
        if(filter){
          //Concatenar parametros
        }
        let response = await UserConfig.APIConnector.get(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
        });
        // console.log("getUsers", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static getActiveOrderForDelivery(deliveryId, app) {
    
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = `${UserConfig.endpointActiveOrder}?deliveryId=${deliveryId}`;
        console.log("ENDPOINT", endpoint)
        let response = await UserConfig.APIConnector.get(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
        });
        // console.log("getUsers", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static getOrderHistoryForDelivery(deliveryId, app) {
    
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = `${UserConfig.endpointOrderHistory}?deliveryId=${deliveryId}`;
        console.log("ENDPOINT", endpoint)
        let response = await UserConfig.APIConnector.get(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
        });
        // console.log("getUsers", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
  
  /******** FIN DELIVERYS *********/

}


// WEBPACK FOOTER //
// ./src/provider/user/UserService.js